import { initialElementsState } from '@blaze-runtime/engine-data-access';

import { initialAIState } from '../ai/ai.state';
import { initialRuntimeState } from '../runtime/runtime.reducer';

import { entityAdapter } from './engine-adapters';
import { type EngineState } from './engine.model';

export const initialEngineState: EngineState = entityAdapter.getInitialState({
  ...initialElementsState,
  ...initialRuntimeState,
  ...initialAIState,
});
